// Elegant scattered bee backdrop — replaces the flat repeating tile look.
// Individually placed bees at varying size, opacity and rotation give the
// feeling of hand-scattered gold dust rather than wallpaper.

const BEE_URL =
  "https://customer-assets-4nw71qhi.emergentagent.net/job_honey-luxury-1/artifacts/ei66463c_Gemini_Generated_Image_rv3509rv3509rv35.webp";

// Deterministic hand-tuned placements. Positions in % of container.
// Sizes in px; opacity 0.06–0.22; rotation degrees.
const BEES = [
  { top: 6,  left: 8,  size: 78,  opacity: 0.18, rot: -12 },
  { top: 12, left: 42, size: 54,  opacity: 0.10, rot: 8 },
  { top: 3,  left: 74, size: 96,  opacity: 0.22, rot: 18 },
  { top: 24, left: 22, size: 44,  opacity: 0.08, rot: -6 },
  { top: 30, left: 62, size: 68,  opacity: 0.14, rot: 4 },
  { top: 40, left: 88, size: 52,  opacity: 0.11, rot: -20 },
  { top: 48, left: 10, size: 90,  opacity: 0.20, rot: 22 },
  { top: 55, left: 46, size: 40,  opacity: 0.07, rot: 12 },
  { top: 62, left: 78, size: 74,  opacity: 0.16, rot: -8 },
  { top: 72, left: 28, size: 60,  opacity: 0.12, rot: 30 },
  { top: 80, left: 60, size: 84,  opacity: 0.19, rot: -14 },
  { top: 86, left: 5,  size: 48,  opacity: 0.09, rot: 6 },
  { top: 92, left: 84, size: 66,  opacity: 0.13, rot: 20 },
];

export default function BeePattern({
  opacity = 1,          // multiplier on the per-bee opacities
  vignette = "radial",  // "radial" | "linear" | "none"
  className = "",
}) {
  return (
    <div
      aria-hidden="true"
      className={`absolute inset-0 pointer-events-none overflow-hidden ${className}`}
    >
      {/* Warm base glow for depth */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 50% 40%, rgba(201,162,76,0.045) 0%, transparent 65%)",
        }}
      />

      {/* Individually placed bees */}
      {BEES.map((b, i) => (
        <img
          key={i}
          src={BEE_URL}
          alt=""
          className="absolute select-none"
          style={{
            top: `${b.top}%`,
            left: `${b.left}%`,
            width: `${b.size}px`,
            height: "auto",
            opacity: b.opacity * opacity,
            transform: `translate(-50%, -50%) rotate(${b.rot}deg)`,
            filter: "brightness(1.15) saturate(1.4) hue-rotate(-4deg)",
          }}
          loading="lazy"
        />
      ))}

      {/* Vignette to blend into the section */}
      {vignette !== "none" && (
        <div
          className="absolute inset-0"
          style={{
            background:
              vignette === "radial"
                ? "radial-gradient(ellipse at center, transparent 25%, #0A0A0A 92%)"
                : "linear-gradient(to bottom, #0A0A0A 0%, transparent 15%, transparent 85%, #0A0A0A 100%)",
          }}
        />
      )}
    </div>
  );
}
